// import { FlexRowBetween, LoaderBar, PageHeader } from 'components'
// import {
//     TaskAddEditModal,
//     TaskSearchForm,
//     InspectionTaskList,
//     TaskAddScheduleModal,
// } from 'page-components'
// import { useState } from 'react'
// import {
//     GetStatusList,
//     GetUserListForGroup,
//     GetCustomerList,
//     GetInspectionTaskList,
//     GetTempleteList,
// } from 'hooks'
// import {
//     InspectionService,
//     InspectionTaskService,
//     PaginationType,
// } from 'utility'
// import { AppPrimaryButton } from 'elements'
// import { useNavigate } from 'react-router-dom'

// export const TaskListScreen = () => {
//     const navigate = useNavigate() // Initialize useNavigate

//     const {
//         data,
//         setData,
//         loading,
//         filter,
//         pageChanged,
//         totalCount,
//         refresh,
//         filterChanged,
//     } = GetInspectionTaskList()
//     const [processing, setProcessing] = useState('')
//     const [modalData, setModalData] = useState({})
//     const [openTaskInspection, setOpenTaskInspection] = useState(false)
//     const [openCasualTaskInspection, setOpenCasualTaskInspection] =
//         useState(false)
//     const { options: templateOptions } = GetTempleteList()
//     const { options: userseOptions } = GetUserListForGroup(PaginationType.All)
//     const { options: customerOptions } = GetCustomerList()
//     const { options: statusOptions } = GetStatusList()

//     const onRemove = async id => {
//         setProcessing('Processing')
//         try {
//             await InspectionTaskService.remove(id)
//             setData(data.filter(ele => ele.TaskId !== id))
//         } catch (error) {
//             console.log(error)
//         } finally {
//             setProcessing('')
//         }
//     }

//     const onReopen = async item => {
//         setProcessing('Reopening')
//         try {
//             // Navigate to the Resume Inspection page
//             navigate(`/app/templates/inspection/${item.TemplateId}`, {
//                 state: { isReopened: true },
//             })
//         } catch (error) {
//             console.log(error)
//         } finally {
//             setProcessing('')
//         }
//     }

//     const onReject = async item => {
//         setProcessing('Rejecting')
//         try {
//             // Add your logic to reject the task
//             console.log('Rejecting task:', item)
//         } catch (error) {
//             console.log(error)
//         } finally {
//             setProcessing('')
//         }
//     }

//     // const onClose = async formdata => {
//     //     try {
//     //         if (formdata) {
//     //             if (formdata?.unique_id) {
//     //                 setProcessing('Saving')
//     //                 await InspectionTaskService.update(formdata)
//     //             } else {
//     //                 setProcessing('Saving')
//     //                 await InspectionTaskService.add(formdata)
//     //             }
//     //             refresh()
//     //         }
//     //     } catch (error) {
//     //         console.log(error)
//     //     } finally {
//     //         setProcessing('')
//     //         setModalData({})
//     //         setOpenTaskInspection(false)
//     //         setOpenCasualTaskInspection(false)
//     //     }
//     // }
//     const onClose = async (formdata) => {
//         console.log('onClose called in parent with formdata:', formdata); // Debug log
//         try {
//             if (formdata) {
//                 if (formdata?.unique_id) {
//                     setProcessing('Saving');
//                     console.log('Updating task:', formdata); // Debug log
//                     await InspectionTaskService.update(formdata);
//                 } else {
//                     setProcessing('Saving');
//                     console.log('Adding new task:', formdata); // Debug log
//                     await InspectionTaskService.add(formdata);
//                 }
//                 refresh();
//             }
//         } catch (error) {
//             console.error('Error in onClose:', error); // Debug log
//         } finally {
//             setProcessing('');
//             setModalData({});
//             setOpenTaskInspection(false);
//             setOpenCasualTaskInspection(false);
//         }
//     };

//     const editInspectionTask = data => {
//         setModalData(data)
//         setOpenTaskInspection(true)
//     }

//     const onViewReport = async item => {
//         const result = await InspectionService.getReport(item.TemplateId)
//         window.open(result.ReportPath)
//     }

//     return (
//         <div>
//             {(processing || loading) && (
//                 <LoaderBar content={processing || 'Loading'} />
//             )}
//             <FlexRowBetween>
//                 <PageHeader header="Task List" />
//                 <span>
//                     {/* Create Task Button */}
//                     <AppPrimaryButton
//                         onClick={() => {
//                             setModalData({})
//                             setOpenTaskInspection(true)
//                         }}
//                     >
//                         Create Task
//                     </AppPrimaryButton>

//                     {/* Create Task Individual Button */}
//                     <AppPrimaryButton
//                         style={{ marginLeft: '10px' }}
//                         onClick={() => {
//                             setModalData({ isIndividual: true })
//                             setOpenCasualTaskInspection(true) // Open Individual modal
//                         }}
//                     >
//                         Schedule Task
//                     </AppPrimaryButton>
//                 </span>
//             </FlexRowBetween>
//             <div className="col-12">
//                 <TaskSearchForm
//                     userseOptions={customerOptions}
//                     statusOptions={statusOptions}
//                     filterChanged={filterChanged}
//                 />
//                 <TaskAddEditModal
//                     onClose={onClose}
//                     data={modalData}
//                     loading={processing}
//                     customerOptions={customerOptions}
//                     templateOptions={templateOptions}
//                     userseOptions={userseOptions}
//                     open={openTaskInspection}
//                 />
//                 <TaskAddScheduleModal
//                     onClose={onClose}
//                     data={modalData}
//                     loading={processing}
//                     customerOptions={customerOptions}
//                     templateOptions={templateOptions}
//                     userseOptions={userseOptions}
//                     open={openCasualTaskInspection} // Separate state
//                 />
//             </div>
//             <div className="my-3">
//                 <InspectionTaskList
//                     data={data}
//                     pageChanged={pageChanged}
//                     totalCount={totalCount}
//                     filter={filter}
//                     onRemove={onRemove}
//                     onEdit={editInspectionTask}
//                     onViewReport={onViewReport}
//                     onReopen={onReopen}
//                     onReject={onReject}
//                 />
//             </div>
//         </div>
//     )
// }
import React, { useEffect, useRef, useState } from 'react'
import { FlexRowBetween, LoaderBar, PageHeader } from 'components'
import {
    TaskAddEditModal,
    ScheduleTaskListScreen,
    TaskAddScheduleModal,
    MonthlyRotation,
    TaskDashboard,
} from 'page-components'
import { HomeDashboardBanner } from 'page-components/home-dashboard/Banner'
import {
    GetUserListForGroup,
    GetNotificationGroupCustomerList,
    GetTempleteList,
    useScheduledTaskList,
} from 'hooks'
import {
    InspectionService,
    InspectionTaskService,
    PaginationType,
    getEmptyAccountFallbackPath,
    canStartAuditsByRole,
} from 'utility'
import {
    getTaskInspectionRouteId,
    getTaskReportId,
    mapDashboardTaskForActions,
} from 'page-components/task/dashboard/task-dashboard-utils'
import { AuthService } from 'utility/services/auth'
import { AppPrimaryButton } from 'elements'
import { useNavigate, useLocation } from 'react-router-dom'
import { Modal, Tab } from 'semantic-ui-react'
import { X } from 'phosphor-react'
import { ViewMonthlyRotation } from 'page-components/task/ViewMonthlyRotation'
import { WaitingCommentsStrip } from 'page-components/question-threads/WaitingCommentsStrip'
import { canCreateMonthlyRotation, MONTHLY_ROTATION_PATH } from 'utility/monthly-rotation'
import {
    MaintenanceTaskDetailModal,
    MaintenanceAlertStrip,
    MaintenanceTaskModal,
} from 'page-components/maintenance'

export const TaskListScreen = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const [dashboardLoading, setDashboardLoading] = useState(true)
    const {
        data: scheduledTasks,
        setData: setScheduledTasks,
        loading: scheduledTasksLoading,
        filter: scheduledTasksFilter,
        totalCount: scheduledTasksTotalCount,
        pageChanged: scheduledTasksPageChanged,
        refresh: refreshScheduledTasks,
        // filterChanged: scheduledTasksFilterChanged,
    } = useScheduledTaskList()
    const [processing, setProcessing] = useState('')
    const [selectedTaskIds, setSelectedTaskIds] = useState([])
    const [selectedScheduledTaskIds, setSelectedScheduledTaskIds] = useState([])
    const [isBulkDeleteModalOpen, setIsBulkDeleteModalOpen] = useState(false)
    const [bulkDeleteType, setBulkDeleteType] = useState('task') // 'task' or 'scheduled'
    const [modalData, setModalData] = useState({})
    const [openTaskInspection, setOpenTaskInspection] = useState(false)
    const [openCasualTaskInspection, setOpenCasualTaskInspection] =
        useState(false)
    const [taskMutationCount, setTaskMutationCount] = useState(0)
    // asset maintenance tasks (EAUDITOR-407): created / opened in their own modals
    const [maintenanceCreateOpen, setMaintenanceCreateOpen] = useState(false)
    const [maintenanceTaskId, setMaintenanceTaskId] = useState(null)
    const [dashboardTasks, setDashboardTasks] = useState([])

    const bumpTaskDashboard = () => {
        setTaskMutationCount(count => count + 1)
    }

    const companyId =
        AuthService.getUser()?.Companies?.[0]?.CompanyId ||
        AuthService.getUser()?.CompanyId

    const { options: templateOptions, data: templateData, loading: templateLoading } = GetTempleteList(PaginationType.All)
    const { options: userseOptions } = GetUserListForGroup(PaginationType.All)
    const {
        options: customerOptions,
        data: customersData,
        loading: customersLoading,
    } = GetNotificationGroupCustomerList(companyId)

    // One-time redirect: If arriving immediately after login and there are no tasks, guide to Template List
    const hadDashboardLoading = useRef(false)
    const hadTemplateLoading = useRef(false)

    useEffect(() => {
        if (dashboardLoading) {
            hadDashboardLoading.current = true
        }
    }, [dashboardLoading])

    useEffect(() => {
        if (templateLoading) {
            hadTemplateLoading.current = true
        }
    }, [templateLoading])

    useEffect(() => {
        try {
            // Prevent redirect if already on the target page
            if (location.pathname === '/app/templates/new-template-library') {
                return
            }

            const tasksLoaded = hadDashboardLoading.current && !dashboardLoading
            const templatesLoaded = hadTemplateLoading.current && !templateLoading

            // Wait for both to finish loading before making decision
            if (tasksLoaded && templatesLoaded) {
                const shouldRedirect = sessionStorage.getItem('shouldRedirectIfNoTasks') === '1'
                const tasksArray = Array.isArray(dashboardTasks) ? dashboardTasks : []
                const templatesArray = Array.isArray(templateData) ? templateData : []
                const tasksEmpty = tasksArray.length === 0
                const templatesEmpty = templatesArray.length === 0

                console.log('Redirect check:', {
                    shouldRedirect,
                    tasksEmpty,
                    templatesEmpty,
                    tasksCount: tasksArray.length,
                    templatesCount: templatesArray.length,
                    currentPath: location.pathname,
                })

                // Only redirect if this is coming from login (shouldRedirect flag is set)
                // If user manually navigates from sidebar, show the empty task list
                if (shouldRedirect && tasksEmpty) {
                    if (templatesEmpty) {
                        const fallbackPath = getEmptyAccountFallbackPath(
                            AuthService.getUser(),
                        )
                        console.log(
                            'Both tasks and templates are empty, redirecting to',
                            fallbackPath,
                        )
                        navigate(fallbackPath, { replace: true })
                    } else {
                        // Tasks are empty but templates exist, redirect to template list
                        console.log('Tasks are empty but templates exist, redirecting to template list...')
                        navigate('/app/templates', { replace: true })
                    }
                    sessionStorage.removeItem('shouldRedirectIfNoTasks')
                } else if (tasksArray.length > 0 || !shouldRedirect) {
                    // Tasks exist OR user navigated manually - no redirect needed
                    // Clear the flag if it exists
                    if (shouldRedirect) {
                        sessionStorage.removeItem('shouldRedirectIfNoTasks')
                    }
                }
            }
        } catch (err) {
            console.error('Error in redirect logic:', err)
        }
    }, [dashboardLoading, dashboardTasks, templateLoading, templateData, navigate, location.pathname])

    const onRemove = async id => {
        setProcessing('Processing')
        try {
            if (Array.isArray(id)) {
                await InspectionTaskService.bulkRemove(id)
            } else {
                await InspectionTaskService.remove(id)
            }
            bumpTaskDashboard()
        } catch (error) {
            console.log(error)
        } finally {
            setProcessing('')
        }
    }

    const onReopen = async item => {
        setProcessing('Reopening')
        try {
            const inspectionRouteId = getTaskInspectionRouteId(
                mapDashboardTaskForActions(item),
            )
            if (!inspectionRouteId) {
                return
            }
            navigate(
                `/app/templates/inspection/${inspectionRouteId}`,
                { state: { isReopened: true } },
            )
        } catch (error) {
            console.log(error)
        } finally {
            setProcessing('')
        }
    }

    const onReject = async (item, comment) => {
        setProcessing('Rejecting')
        try {
            await InspectionService.taskRejection({
                TaskId: item.TaskId,
                comment,
            })
            bumpTaskDashboard()
        } catch (error) {
            console.error('Error rejecting task:', error)
            throw error
        } finally {
            setProcessing('')
        }
    }

    const editInspectionTask = taskData => {
        setModalData(taskData)
        setOpenTaskInspection(true)
    }

    // const onClose = async (formdata, isScheduledTask = false) => {
    //     console.log('onClose called in parent with formdata:', formdata)
    //     try {
    //         if (formdata) {
    //             if (formdata?.unique_id) {
    //                 setProcessing('Saving')
    //                 console.log('Updating task:', formdata)
    //                 try {
    //                     const response =
    //                         await InspectionTaskService.scheduleTask(formdata)
    //                     console.log('API Response:', response)
    //                     refreshScheduledTasks()
    //                 } catch (error) {
    //                     console.error('Error scheduling task:', error)
    //                 }
    //             } else {
    //                 setProcessing('Saving')
    //                 console.log('Adding new task:', formdata)

    //                 console.log(isScheduledTask, 'Schedule task console')
    //                 if (isScheduledTask) {
    //                     // Schedule the new task using the API
    //                     try {
    //                         const response =
    //                             await InspectionTaskService.scheduleTask(
    //                                 formdata,
    //                             )
    //                         console.log('API Response:', response)
    //                         refreshScheduledTasks()
    //                         setScheduledTasks(prevTasks => [
    //                             ...prevTasks,
    //                             response,
    //                         ])
    //                     } catch (error) {
    //                         console.error('Error scheduling task:', error)
    //                     }
    //                 } else {
    //                     // Add the new task to the regular task list
    //                     await InspectionTaskService.add(formdata)
    //                     refresh() // Refresh the regular task list
    //                 }
    //             }
    //         }
    //     } catch (error) {
    //         console.error('Error in onClose:', error)
    //     } finally {
    //         setProcessing('')
    //         setModalData({})
    //         setOpenTaskInspection(false)
    //         setOpenCasualTaskInspection(false)
    //     }
    // }
    const onClose = async (formdata, isScheduledTask = false) => {
        console.log('onClose called in parent with formdata:', formdata)
        try {
            if (formdata?._refreshScheduled) {
                refreshScheduledTasks()
                return
            }
            if (formdata) {
                setProcessing('Saving') // Show loading indicator

                if (formdata?.Id) {
                    // If formdata.Id exists, it means we're updating a task
                    console.log('Updating task:', formdata)
                    try {
                        const response =
                            await InspectionTaskService.updateSchedule(formdata)
                        console.log('Update API Response:', response)
                        refreshScheduledTasks() // Refresh the scheduled tasks list
                    } catch (error) {
                        console.error('Error updating task:', error)
                    }
                } else if (formdata?.TaskId && !isScheduledTask) {
                    try {
                        await InspectionTaskService.update(formdata)
                        bumpTaskDashboard()
                    } catch (error) {
                        console.error('Error updating task:', error)
                    }
                } else {
                    console.log('Adding new task:', formdata)

                    if (isScheduledTask) {
                        try {
                            const response =
                                await InspectionTaskService.scheduleTask(
                                    formdata,
                                )
                            console.log('Create API Response:', response)
                            refreshScheduledTasks()
                            setScheduledTasks(prevTasks => [
                                ...prevTasks,
                                response,
                            ])
                        } catch (error) {
                            console.error('Error scheduling task:', error)
                        }
                    } else {
                        try {
                            await InspectionTaskService.add(formdata)
                            bumpTaskDashboard()
                        } catch (error) {
                            console.error('Error adding task:', error)
                        }
                    }
                }
            }
        } catch (error) {
            console.error('Error in onClose:', error)
        } finally {
            setProcessing('') // Hide loading indicator
            setModalData({}) // Reset modal data
            setOpenTaskInspection(false) // Close the task inspection modal
            setOpenCasualTaskInspection(false) // Close the casual task inspection modal
        }
    }

    const editScheduledTask = data => {
        setModalData(data)
        setOpenCasualTaskInspection(true)
    }

    const removeScheduledTask = async id => {
        console.log('Removing task with ID:', id) // Debugging
        if (!id || (Array.isArray(id) && id.length === 0)) {
            console.error('Invalid ID provided for deletion')
            return
        }
        setProcessing('Deleting')
        try {
            if (Array.isArray(id)) {
                await Promise.all(id.map(i => InspectionTaskService.removeSchedule(i)))
                console.log('Tasks removed successfully')
            } else {
                const response = await InspectionTaskService.removeSchedule(id)
                console.log('Task removed successfully:', response)
            }
            refreshScheduledTasks()
        } catch (error) {
            console.error('Error removing scheduled task(s):', error)
            // alert(`Failed to remove task: ${error?.error || 'Unknown error'}`)
        } finally {
            setProcessing('')
        }
    }

    const onViewReport = async item => {
        const task = mapDashboardTaskForActions(item)
        const reportId = getTaskReportId(task)
        if (!reportId) return
        const result = await InspectionService.getReport(reportId)
        window.open(result.ReportPath)
    }

    const handleBulkDeleteClick = (type) => {
        setBulkDeleteType(type)
        setIsBulkDeleteModalOpen(true)
    }

    const confirmBulkDelete = async () => {
        setIsBulkDeleteModalOpen(false)
        if (bulkDeleteType === 'task') {
            await onRemove(selectedTaskIds)
            setSelectedTaskIds([])
        } else {
            await removeScheduledTask(selectedScheduledTaskIds)
            setSelectedScheduledTaskIds([])
        }
    }

    const selectedTasks = dashboardTasks.filter(item =>
        selectedTaskIds.includes(item.TaskId),
    )
    const selectedScheduledTasks = (scheduledTasks || []).filter(item => selectedScheduledTaskIds.includes(item.Id))

    // department role model (opted-in companies only): Viewers / department heads who audit nothing do not plan tasks
    const canPlanTasks = canStartAuditsByRole(AuthService.getUser())
    const canCreateRotation = canCreateMonthlyRotation(AuthService.getUser())
    const taskPageLabel = companyId === 34930 ? 'Audit Report' : 'Task List'

    const panes = [
        {
            menuItem: taskPageLabel,
            render: () => (
                <div>
                    {(processing) && <LoaderBar content={processing} />}
                    <TaskDashboard
                        onViewReport={onViewReport}
                        onEdit={editInspectionTask}
                        onRemove={onRemove}
                        onReopen={onReopen}
                        onReject={onReject}
                        templateOptions={templateOptions}
                        customerOptions={customerOptions}
                        customersData={customersData}
                        customersLoading={customersLoading}
                        companyId={companyId}
                        auditorOptions={userseOptions}
                        taskMutationCount={taskMutationCount}
                        selectedIds={selectedTaskIds}
                        onSelectionChange={setSelectedTaskIds}
                        onBulkDelete={() => handleBulkDeleteClick('task')}
                        onTasksChange={setDashboardTasks}
                        onLoadingChange={setDashboardLoading}
                        onOpenMaintenance={setMaintenanceTaskId}
                    />
                </div>
            ),
        },
        ...(companyId !== 34930
            ? [{
                menuItem: 'Schedule Task List',
                render: () => (
                    <div>
                        {(processing || scheduledTasksLoading) && (
                            <LoaderBar content={processing || 'Loading'} />
                        )}
                        {selectedScheduledTaskIds.length > 0 && (
                            <div className="my-2 d-flex justify-content-end align-items-center gap-2">
                                <span>{selectedScheduledTaskIds.length} scheduled tasks selected</span>
                                <AppPrimaryButton
                                    style={{ backgroundColor: '#dc3545' }}
                                    onClick={() => handleBulkDeleteClick('scheduled')}
                                >
                                    Delete Selected
                                </AppPrimaryButton>
                            </div>
                        )}
                        <ScheduleTaskListScreen
                            scheduledTasks={scheduledTasks}
                            onEdit={editScheduledTask}
                            onRemove={removeScheduledTask}
                            customerOptions={customerOptions}
                            loading={scheduledTasksLoading}
                            pageChanged={scheduledTasksPageChanged}
                            totalCount={scheduledTasksTotalCount}
                            filter={scheduledTasksFilter}
                            selectedIds={selectedScheduledTaskIds}
                            onSelectionChange={setSelectedScheduledTaskIds}
                        />
                    </div>
                ),
            }]
            : []),
        ...(companyId === 60551 && canCreateRotation
            ? [{
                menuItem: 'Monthly Rotation',
                render: () => <MonthlyRotation />,
            }]
            : []),
        ...(companyId === 34930 || companyId === 60551
            ? [{
                menuItem: 'View Monthly Rotation',
                render: () => <ViewMonthlyRotation />,
            }]
            : []),
    ]

    return (
        <div>
            <HomeDashboardBanner />
            {/* Buttons for Create Task and Schedule Task */}
            <FlexRowBetween style={{ marginBottom: '20px' }}>
                <PageHeader header={taskPageLabel} />
                <span>
                    {companyId !== 34930 && canPlanTasks && (
                        <AppPrimaryButton
                            onClick={() => {
                                setModalData({})
                                setOpenTaskInspection(true)
                            }}
                        >
                            Create Task
                        </AppPrimaryButton>
                    )}
                    {companyId !== 34930 && canPlanTasks && (
                        <AppPrimaryButton
                            style={{ marginLeft: '10px' }}
                            onClick={() => {
                                setModalData({ isIndividual: true })
                                setOpenCasualTaskInspection(true)
                            }}
                        >
                            Schedule Task
                        </AppPrimaryButton>
                    )}
                    {canCreateRotation && (
                        <AppPrimaryButton
                            style={companyId !== 34930 && canPlanTasks ? { marginLeft: '10px' } : undefined}
                            onClick={() => navigate(MONTHLY_ROTATION_PATH)}
                        >
                            Create Monthly Rotation
                        </AppPrimaryButton>
                    )}
                </span>
            </FlexRowBetween>

            {/* Maintenance work waiting for this user (EAUDITOR-409) */}
            <MaintenanceAlertStrip onOpenTask={id => setMaintenanceTaskId(id)} refreshKey={taskMutationCount} />

            {/* Question comments waiting for this user's reply / review */}
            <WaitingCommentsStrip refreshKey={taskMutationCount} />

            {/* Tabs */}
            <Tab menu={{ secondary: true, pointing: true }} panes={panes} />

            {/* Modals */}
            <TaskAddEditModal
                onClose={formdata => onClose(formdata, false)} // Regular task
                data={modalData}
                loading={processing}
                customerOptions={customerOptions}
                templateOptions={templateOptions}
                userseOptions={userseOptions}
                open={openTaskInspection}
                onSwitchToMaintenance={() => {
                    setOpenTaskInspection(false)
                    setModalData({})
                    setMaintenanceCreateOpen(true)
                }}
            />
            <MaintenanceTaskModal
                open={maintenanceCreateOpen}
                templateOptions={templateOptions}
                userOptions={userseOptions}
                customerOptions={customerOptions}
                onSwitchToInspection={() => {
                    setMaintenanceCreateOpen(false)
                    setModalData({})
                    setOpenTaskInspection(true)
                }}
                onClose={created => {
                    setMaintenanceCreateOpen(false)
                    if (created) bumpTaskDashboard()
                }}
            />
            <MaintenanceTaskDetailModal
                open={!!maintenanceTaskId}
                taskId={maintenanceTaskId}
                templateOptions={templateOptions}
                userOptions={userseOptions}
                onClose={changed => {
                    setMaintenanceTaskId(null)
                    if (changed) bumpTaskDashboard()
                }}
            />
            <TaskAddScheduleModal
                onClose={formdata => onClose(formdata, true)}
                data={modalData}
                loading={processing}
                customerOptions={customerOptions}
                templateOptions={templateOptions}
                userseOptions={userseOptions}
                open={openCasualTaskInspection}
            />

            {/* Bulk Delete Modal */}
            <Modal open={isBulkDeleteModalOpen} onClose={() => setIsBulkDeleteModalOpen(false)} size="small">
                <Modal.Header>
                    <FlexRowBetween>
                        <span>Confirm Bulk Deletion</span>
                        <X className="pointer" size={24} onClick={() => setIsBulkDeleteModalOpen(false)} />
                    </FlexRowBetween>
                </Modal.Header>
                <Modal.Content scrolling>
                    <p>Are you sure you want to delete the following {bulkDeleteType === 'task' ? 'tasks' : 'scheduled tasks'}?</p>
                    <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #eee', padding: '10px', borderRadius: '4px' }}>
                        <ul>
                            {(bulkDeleteType === 'task' ? selectedTasks : selectedScheduledTasks).map((item, idx) => (
                                <li key={idx} style={{ padding: '4px 0' }}>
                                    {bulkDeleteType === 'task'
                                        ? (item.TemplateName || item.Title || item.CustomerName)
                                        : (item.Title || `${item.TemplateName}-${item.CustomerName}`)}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <AppPrimaryButton onClick={() => setIsBulkDeleteModalOpen(false)}>
                        Cancel
                    </AppPrimaryButton>
                    <AppPrimaryButton
                        onClick={confirmBulkDelete}
                        style={{ backgroundColor: '#dc3545' }}
                    >
                        Confirm Delete
                    </AppPrimaryButton>
                </Modal.Actions>
            </Modal>
        </div>
    )
}
